function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class RuntimeError extends Error {
    constructor(errorOrMessage, error){
        if (error) {
            super(errorOrMessage);
            _define_property(this, "name", 'RuntimeError');
            _define_property(this, "originalError", void 0);
            this.originalError = error;
        } else {
            if (typeof errorOrMessage === 'string') {
                super(errorOrMessage);
                _define_property(this, "name", 'RuntimeError');
                _define_property(this, "originalError", void 0);
            } else {
                super(errorOrMessage === null || errorOrMessage === void 0 ? void 0 : errorOrMessage.message);
                _define_property(this, "name", 'RuntimeError');
                _define_property(this, "originalError", void 0);
                this.originalError = errorOrMessage;
            }
        }
    }
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lcnJvcnMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNsYXNzIFJ1bnRpbWVFcnJvciBleHRlbmRzIEVycm9yIHtcbiAgcHVibGljIG5hbWUgPSAnUnVudGltZUVycm9yJ1xuICBwdWJsaWMgb3JpZ2luYWxFcnJvcj86IEVycm9yXG5cbiAgcHVibGljIGNvbnN0cnVjdG9yKGVycm9yT3JNZXNzYWdlOiBFcnJvciB8IHN0cmluZylcbiAgcHVibGljIGNvbnN0cnVjdG9yKG1lc3NhZ2U6IHN0cmluZywgZXJyb3I6IEVycm9yKVxuXG4gIHB1YmxpYyBjb25zdHJ1Y3RvcihlcnJvck9yTWVzc2FnZTogRXJyb3IgfCBzdHJpbmcsIGVycm9yPzogRXJyb3IpIHtcbiAgICBpZiAoZXJyb3IpIHtcbiAgICAgIHN1cGVyKGVycm9yT3JNZXNzYWdlIGFzIHN0cmluZylcblxuICAgICAgdGhpcy5vcmlnaW5hbEVycm9yID0gZXJyb3JcbiAgICB9IGVsc2Uge1xuICAgICAgaWYgKHR5cGVvZiBlcnJvck9yTWVzc2FnZSA9PT0gJ3N0cmluZycpIHtcbiAgICAgICAgc3VwZXIoZXJyb3JPck1lc3NhZ2UpXG4gICAgICB9IGVsc2Uge1xuICAgICAgICBzdXBlcihlcnJvck9yTWVzc2FnZT8ubWVzc2FnZSlcblxuICAgICAgICB0aGlzLm9yaWdpbmFsRXJyb3IgPSBlcnJvck9yTWVzc2FnZVxuICAgICAgfVxuICAgIH1cbiAgfVxufVxuIl0sIm5hbWVzIjpbIlJ1bnRpbWVFcnJvciIsIkVycm9yIiwiZXJyb3JPck1lc3NhZ2UiLCJlcnJvciIsIm5hbWUiLCJvcmlnaW5hbEVycm9yIiwibWVzc2FnZSJdLCJyYW5nZU1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7IiwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLE1BQU1BLHFCQUFxQkM7SUFPaEMsWUFBbUJDLGNBQThCLEVBQUVDLEtBQWEsQ0FBRTtRQUNoRSxJQUFJQSxPQUFPO1lBQ1QsS0FBSyxDQUFDRDtZQVJWLHVCQUFPRSxRQUFPO1lBQ2QsdUJBQU9DLGlCQUFQLEtBQUE7WUFTSSxJQUFJLENBQUNBLGFBQWEsR0FBR0Y7UUFDdkIsT0FBTztZQUNMLElBQUksT0FBT0QsbUJBQW1CLFVBQVU7Z0JBQ3RDLEtBQUssQ0FBQ0E7Z0JBYlosdUJBQU9FLFFBQU87Z0JBQ2QsdUJBQU9DLGlCQUFQLEtBQUE7WUFhSSxPQUFPO2dCQUNMLEtBQUssQ0FBQ0gsMkJBQUFBLHFDQUFBQSxlQUFnQkksT0FBTztnQkFmbkMsdUJBQU9GLFFBQU87Z0JBQ2QsdUJBQU9DLGlCQUFQLEtBQUE7Z0JBZ0JNLElBQUksQ0FBQ0EsYUFBYSxHQUFHSDtZQUN2QjtRQUNGO0lBQ0Y7QUFDRiJ9